import { DataItem } from 'scrivito'

import { DataClassName } from '@/Data/const'
import { DataBinary } from '@/utils/dataBinaryToUrl'

export const getImageBinary: (
  dataClassName: string,
  dataItem: DataItem | undefined,
) => DataBinary | undefined = (dataClassName, dataItem) => {
  switch (dataClassName) {
    case DataClassName.COMPANY:
    case DataClassName.PERSON:
      return dataItem?.get('image') as DataBinary
    case DataClassName.DOCUMENT:
      return dataItem?.get('bodyThumbnail') as DataBinary
    default:
      return undefined
  }
}
